<template>
    <nav class="main-nav" :class="{show:showNav}">
        <div class="close-btn hide-on-desktop" @click="hideNav">
            <font-awesome-icon icon="times"/>
        </div>
        <div class="hub" :class="{show:showHub, sfrHub: isThemeSfr}" v-on-clickaway="closeHUB" :style="{ 'width': isThemeSfr ||  isThemeCatsafe || isThemeBeepiz ? '370px !important' : '440px'}">
            <div class="hubContent">
                <div class="logoHub">
                    <img v-if="isThemeSfr"
                         :src="require('@/assets/img/logo2-sfr.png')"
                         class="img-fluid m-x-auto"
                    >
                    <img v-else-if="isThemeCatsafe"
                         :src="require('@/assets/img/logo-catsafe-large.png')"
                         class="img-fluid m-x-auto"
                    >
                    <img
                      v-else-if="isThemeBeepiz"
                      src="data:image/png;base64,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"
                      class="img-fluid m-x-auto" alt="Suivi de flotte"
                    >

                  <div v-else style="padding-top: 12px; padding-bottom: 12px">
                    <svg  width="50%" height="80%" viewBox="0 0 432 70" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
                        <g transform="matrix(1,0,0,1,-158.236,-67.992)">
                            <path d="M264.114,90.527C265.857,90.527 267.574,90.77 269.265,91.257C270.957,91.743 272.442,92.405 273.72,93.242L271.378,98.062C270.1,97.315 268.733,96.707 267.28,96.238C265.826,95.768 264.601,95.533 263.605,95.533C262.791,95.533 262.14,95.683 261.654,95.983C261.167,96.283 260.924,96.721 260.924,97.298C260.924,98.068 261.3,98.656 262.052,99.063C262.805,99.471 263.99,99.906 265.608,100.37C267.305,100.857 268.697,101.343 269.783,101.83C270.869,102.316 271.808,103.046 272.6,104.019C273.392,104.992 273.788,106.288 273.788,107.905C273.788,109.478 273.358,110.827 272.498,111.953C271.638,113.079 270.473,113.925 269.002,114.49C267.531,115.056 265.879,115.339 264.047,115.339C262.033,115.339 260.041,114.991 258.073,114.295C256.104,113.599 254.39,112.652 252.93,111.452L255.323,106.684C256.557,107.747 258.008,108.621 259.676,109.306C261.345,109.99 262.825,110.332 264.114,110.332C265.11,110.332 265.888,110.154 266.448,109.798C267.008,109.441 267.288,108.912 267.288,108.211C267.288,107.419 266.898,106.816 266.117,106.404C265.336,105.991 264.126,105.563 262.485,105.122C260.822,104.658 259.45,104.194 258.37,103.731C257.289,103.267 256.361,102.56 255.586,101.609C254.811,100.659 254.424,99.409 254.424,97.858C254.424,96.376 254.823,95.087 255.62,93.989C256.418,92.892 257.552,92.04 259.023,91.435C260.494,90.83 262.191,90.527 264.114,90.527Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M299.041,104.851C299.041,106.978 298.589,108.83 297.684,110.409C296.778,111.987 295.491,113.203 293.823,114.058C292.154,114.912 290.194,115.339 287.942,115.339C285.668,115.339 283.688,114.912 282.002,114.058C280.316,113.203 279.015,111.987 278.099,110.409C277.182,108.83 276.724,106.978 276.724,104.851L276.724,90.731L282.902,90.731L282.902,104.851C282.902,106.469 283.371,107.758 284.31,108.72C285.249,109.682 286.471,110.163 287.976,110.163C289.458,110.163 290.646,109.687 291.54,108.737C292.434,107.787 292.881,106.491 292.881,104.851L292.881,90.731L299.041,90.731L299.041,104.851Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <rect x="303.471" y="91.002" width="6.195" height="24.337" style="fill:rgb(51,51,51);"/>
                          <path d="M321.511,115.339L312.058,91.002L318.66,91.002L324.889,108.907L331.1,91.002L337.464,91.002L327.909,115.339L321.511,115.339Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <rect x="339.84" y="91.002" width="6.195" height="24.337" style="fill:rgb(51,51,51);"/>
                          <path d="M367.316,91.002C369.839,91.002 372.079,91.514 374.037,92.538C375.994,93.562 377.519,94.993 378.61,96.832C379.702,98.67 380.248,100.783 380.248,103.17C380.248,105.535 379.691,107.64 378.576,109.484C377.462,111.328 375.909,112.765 373.918,113.794C371.927,114.824 369.641,115.339 367.061,115.339L356.845,115.339L356.845,91.002L367.316,91.002ZM363.039,110.4L367.452,110.4C368.708,110.4 369.828,110.1 370.812,109.501C371.796,108.901 372.566,108.055 373.12,106.964C373.675,105.872 373.952,104.619 373.952,103.204C373.952,101.79 373.663,100.534 373.086,99.437C372.509,98.339 371.703,97.482 370.668,96.866C369.633,96.249 368.47,95.941 367.18,95.941L363.039,95.941L363.039,110.4Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M389.684,95.873L389.684,100.71L401.293,100.71L401.293,105.58L389.684,105.58L389.684,110.468L402.922,110.468L402.922,115.339L383.49,115.339L383.49,91.002L402.548,91.002L402.548,95.873L389.684,95.873Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M419.061,95.873L419.061,101.507L429.973,101.507L429.973,106.378L419.061,106.378L419.061,115.339L412.866,115.339L412.866,91.002L430.907,91.002L430.907,95.873L419.061,95.873Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M450.356,110.163L450.356,115.339L433.843,115.339L433.843,91.002L440.037,91.002L440.037,110.163L450.356,110.163Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M464.832,90.527C467.31,90.527 469.553,91.067 471.561,92.148C473.57,93.228 475.145,94.705 476.288,96.577C477.431,98.45 478.002,100.546 478.002,102.865C478.002,105.207 477.431,107.328 476.288,109.229C475.145,111.13 473.57,112.623 471.561,113.71C469.553,114.796 467.31,115.339 464.832,115.339C462.377,115.339 460.148,114.796 458.146,113.71C456.143,112.623 454.568,111.13 453.419,109.229C452.271,107.328 451.697,105.207 451.697,102.865C451.697,100.523 452.271,98.416 453.419,96.543C454.568,94.671 456.137,93.2 458.129,92.131C460.12,91.062 462.354,90.527 464.832,90.527ZM464.9,95.703C463.678,95.703 462.538,96.017 461.48,96.645C460.423,97.273 459.583,98.136 458.96,99.233C458.338,100.331 458.027,101.553 458.027,102.899C458.027,104.245 458.338,105.476 458.96,106.59C459.583,107.705 460.423,108.579 461.48,109.212C462.538,109.846 463.678,110.163 464.9,110.163C466.133,110.163 467.265,109.846 468.294,109.212C469.324,108.579 470.141,107.705 470.747,106.59C471.352,105.476 471.655,104.245 471.655,102.899C471.655,101.553 471.352,100.331 470.747,99.233C470.141,98.136 469.324,97.273 468.294,96.645C467.265,96.017 466.133,95.703 464.9,95.703Z" style="fill:rgb(251,113,32);fill-rule:nonzero;"/>
                          <path d="M491.732,95.975L491.732,115.339L485.537,115.339L485.537,95.975L478.274,95.975L478.274,90.968L499.063,90.968L499.063,95.975L491.732,95.975Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M512.963,95.975L512.963,115.339L506.768,115.339L506.768,95.975L499.505,95.975L499.505,90.968L520.294,90.968L520.294,95.975L512.963,95.975Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M529.119,95.873L529.119,100.71L540.728,100.71L540.728,105.58L529.119,105.58L529.119,110.468L542.357,110.468L542.357,115.339L522.925,115.339L522.925,91.002L541.984,91.002L541.984,95.873L529.119,95.873Z" style="fill:rgb(51,51,51);fill-rule:nonzero;"/>
                          <path d="M546.34,111.999C546.835,111.999 547.239,112.154 547.551,112.463C547.864,112.772 548.02,113.171 548.02,113.659C548.02,114.154 547.864,114.558 547.551,114.87C547.239,115.183 546.835,115.339 546.34,115.339C545.845,115.339 545.445,115.183 545.139,114.87C544.833,114.558 544.68,114.154 544.68,113.659C544.68,113.164 544.833,112.764 545.139,112.458C545.445,112.152 545.845,111.999 546.34,111.999Z" style="fill:rgb(251,113,32);fill-rule:nonzero;"/>
                          <path d="M559.953,115.183L553.508,106.56L553.508,115.183L550.168,115.183L550.168,101.179L553.313,101.179L559.768,109.821L559.768,101.179L563.088,101.179L563.088,115.183L559.953,115.183Z" style="fill:rgb(251,113,32);fill-rule:nonzero;"/>
                          <path d="M569.446,103.981L569.446,106.765L576.125,106.765L576.125,109.567L569.446,109.567L569.446,112.38L577.063,112.38L577.063,115.183L565.881,115.183L565.881,101.179L576.848,101.179L576.848,103.981L569.446,103.981Z" style="fill:rgb(251,113,32);fill-rule:nonzero;"/>
                          <path d="M585.842,104.04L585.842,115.183L582.278,115.183L582.278,104.04L578.098,104.04L578.098,101.159L590.061,101.159L590.061,104.04L585.842,104.04Z" style="fill:rgb(251,113,32);fill-rule:nonzero;"/>
                          <path d="M158.236,101.413C178.245,101.548 194.448,117.833 194.448,137.874L176.476,137.874C176.476,127.752 168.326,119.519 158.236,119.386L158.236,101.413ZM158.236,69.603C195.802,69.738 226.258,100.277 226.258,137.874L196.426,137.874C196.426,116.742 179.337,99.57 158.236,99.435L158.236,69.603ZM178.584,67.992L211.685,67.992C220.761,67.992 228.118,75.349 228.118,84.425L228.118,118.144C221.353,94.081 202.525,75.046 178.584,67.992Z" style="fill:rgb(51,51,51);"/>
                          <path d="M158.236,122.213C166.766,122.346 173.65,129.312 173.65,137.874L173.648,137.874C165.136,137.874 158.236,130.974 158.236,122.462L158.236,122.213Z" style="fill:rgb(251,113,32);"/>
                        </g>
                    </svg>
                  </div>
                </div>
                <!-- Beepiz Mode -->
                <ul v-if="isThemeBeepiz" class="listeHub m-x-auto" style="display: flex; justify-content: center; height: 150px; align-items: center;">
                    <li :class="{disabled: false}" >
                      <a :href="hubHelper.getLink('beepiz')">
                        <img src="https://client.suivideflotte.net/img/app/sdf-beepiz-duo.png">
                        <span>Beepiz</span>
                      </a>
                    </li>
                    <li class="active" :class="{disabled: false}">
                      <a :href="hubHelper.getLink('beepizManager')">
                        <img src="https://client.suivideflotte.net/img/app/sdf-manager-duo.png">
                        <span>Manager</span>
                      </a>
                    </li>
                    <li>
                      <a :href="hubHelper.getLink('beepizSupport')">
                        <img src="https://client.suivideflotte.net/img/app/sdf-assistance-duo.png">
                        <span>Assistance</span>
                      </a>
                    </li>
                </ul>
                <!-- SFR Mode -->
                <ul v-else-if="isThemeSfr" class="listeHub m-x-auto" style="display: flex; justify-content: center; height: 150px; align-items: center;">
                  <li :class="{disabled: false}" >
                    <a :href="hubHelper.getLink('sfrBeepiz')">
                      <img src="https://client.suivideflotte.net/img/logo-sfr-dark.png">
                      <span>SFR DATI</span>
                    </a>
                  </li>
                  <li class="active" :class="{disabled: false}">
                    <a :href="hubHelper.getLink('sfrManager')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-manager-duo.png">
                      <span>Manager</span>
                    </a>
                  </li>
                  <li>
                    <a :href="hubHelper.getLink('sfrSupport')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-assistance-duo.png">
                      <span>Assistance</span>
                    </a>
                  </li>
                </ul>
                <!-- CAT'SAFE Mode -->
                <ul v-else-if="isThemeCatsafe" class="listeHub m-x-auto" style="display: flex; justify-content: center; height: 150px; align-items: center;">
                  <li :class="{disabled: false}" >
                    <a class="link-custom-icon" :href="hubHelper.getLink('catsafeBeepiz')">
                      <div class="custom-icon">
                        <img :src="require('@/assets/img/logo-catsafe-square.png')">
                      </div>
                      <span>CAT'SAFE</span>
                    </a>
                  </li>
                  <li class="active" :class="{disabled: false}">
                    <a :href="hubHelper.getLink('catsafeManager')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-manager-duo.png">
                      <span>Manager</span>
                    </a>
                  </li>
                  <li>
                    <a :href="hubHelper.getLink('catsafeSupport')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-assistance-duo.png">
                      <span>Assistance</span>
                    </a>
                  </li>
                </ul>
                <!-- Default -->
                <ul v-else class="listeHub m-x-auto">
                  <li :class="{disabled:!hasHubAccess('fleet')}">
                    <a :href="hubHelper.getLink('fleet')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-marker-duo.png">
                      <span>Géolocalisation</span>
                    </a>
                  </li>
                  <li :class="{disabled:!hasHubAccess('park')}">
                    <a :href="hubHelper.getLink('park')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-parc-duo.png">
                      <span>Gestion de Parc</span>
                    </a>
                  </li>
                  <li :class="{disabled:!hasHubAccess('mission')}">
                    <a :href="hubHelper.getLink('mission')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-mission-duo.png">
                      <span>SuiviMissions</span>
                    </a>
                  </li>
                  <li :class="{disabled:!hasHubAccess('bom')}">
                    <a :href="hubHelper.getLink('bom')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-bom-duo.png">
                      <span>Editeur&nbsp;BOM</span>
                    </a>
                  </li>
                  <li :class="{disabled:!hasHubAccess('vision')}">
                    <a :href="hubHelper.getLink('vision')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-vision-duo.png">
                      <span>SuiviVision</span>
                    </a>
                  </li>
                  <li class="active" :class="{disabled:!hasHubAccess('admin')}">
                    <a href="#">
                      <img src="https://client.suivideflotte.net/img/app/sdf-manager-duo.png">
                      <span>Manager</span>
                    </a>
                  </li>
                  <li>
                    <a :href="hubHelper.getLink('support')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-assistance-duo.png">
                      <span>Assistance</span>
                    </a>
                  </li>
                  <li :class="{disabled:!hasHubAccess('beepiz')}">
                    <a :href="hubHelper.getLink('beepiz')">
                      <img src="https://client.suivideflotte.net/img/app/sdf-beepiz-duo.png">
                      <span>Beepiz</span>
                    </a>
                  </li>
                </ul>
            </div>
        </div>
        <ul>
            <li class="nav-logo" v-html="" @click="toggleHub">
                <div class="logo-manager">
                    <svg viewBox="0 0 2048 1792" xmlns="http://www.w3.org/2000/svg"><path d="M657 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zm1071 637q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-1024-1277q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm704 384q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zm576 225q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zm-128-609q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z" fill="#212121"/></svg>
                </div>
            </li>
            <li class="nav-link" v-can="'admin-browse-users'">
                <router-link :to="{name:'usersList'}"><font-awesome-icon icon="user-circle"/><span>{{ $t('nav.users') }}</span></router-link>
            </li>
            <li class="nav-link hide-on-mobile" v-can="'admin-manage-plugins'" >
                <router-link :to="{name:'pluginsList'}"><font-awesome-icon icon="puzzle-piece"/><span>{{ $t('nav.plugins') }}</span></router-link>
            </li>
            <li class="nav-link" v-can="'admin-company-client || admin-contacts-client || admin-bills-client'">
                <router-link :to="{name:'papersIndex'}"><font-awesome-icon icon="file-alt"/><span>{{ $t('nav.papers') }}</span></router-link>
            </li>
        </ul>
        <ul class="stick-to-bottom">
            <li class="nav-link" v-if="canLogout && !hasFrom">
                <router-link to="/logout"><font-awesome-icon icon="power-off"/><span>{{ $t('nav.logout') }}</span></router-link>
            </li>
            <li class="nav-link" v-if="hasFrom">
                <a :href="getFrom" @click="closeManager"><font-awesome-icon icon="sign-out-alt" flip="horizontal"/><span>{{ $t('nav.exit') }}</span></a>
            </li>
        </ul>
    </nav>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway';
import Auth from '@/services/auth.js';
import HubHelper from '@s/hub'
import {mapGetters,mapMutations} from 'vuex'
import _find from 'lodash/find'
import Utils from '@s/utils.js'

export default {
    name: 'navbar',
    props: {
        acl: {
            type: [Object,Array],
            default: function(){
                return window.V.acl;
            }
        }
    },
    computed: {
        ...mapGetters({
            showNav: 'UI/showNav',
            permissions: 'Auth/permissions'
        }),
        canLogout(){
            if(sessionStorage.getItem('NO_LOGOUT') === '1'){
                return false;
            }
            return true;
        },
        hasFrom(){
            if(sessionStorage.getItem('ADMINV5_FROM')){
                return true;
            }
            return false;
        },
        getFrom(){
            if(sessionStorage.getItem('ADMINV5_FROM')){
                return sessionStorage.getItem('ADMINV5_FROM');
            }
            return null;
        },
        hubHelper(){
            return HubHelper
        },
        sfrMode() {
          const locationHost = window.location.host

          if (locationHost.includes('sfr') && locationHost.includes('beepiz')){
            return true
          }

          return false
        },
        beepizMode() {
          const locationHost = window.location.host

          if (!locationHost.includes('sfr') && locationHost.includes('beepiz')){
            return true
          }

          return false
        },
    },
    mixins: [clickaway],
    data: () => ({
        isThemeSfr: Utils.isThemeSfr(),
        isThemeCatsafe: Utils.isThemeCatsafe(),
        isThemeBeepiz: Utils.isThemeBeepiz(),
        firstTime: true,
        currentSecondNavKey: '',
        secondNav: {
            configurations: {
                show: false,
                firstTime: true
            },
            preferences: {
                show: false,
                firstTime: true
            },
            plans: {
                show: false,
                firstTime: true
            },
            devices: {
                show: false,
                firstTime: true
            },
            patrols: {
                show: false,
                firstTime: true
            }
        },
        showHub: false,
        firstTimeHub: true,
    }),
    methods: {
        ...mapMutations({
            setShowNav: 'UI/showNav'
        }),
        toggleSecondNav: function (key) {
            this.secondNav[key].show = !this.secondNav[key].show;
            this.secondNav[key].firstTime = true;
        },
        closeSecondNav: function (key) {
            if (this.secondNav[key].show && !this.secondNav[key].firstTime) {
                this.secondNav[key].show = false;
                this.secondNav[key].firstTime = true;
            }
            else {
                this.secondNav[key].firstTime = false;
            }
        },
        closeSecondNavConfigurations: function () {
            this.closeSecondNav('configurations');
        },
        closeSecondNavDevices: function () {
            this.closeSecondNav('devices');
        },
        closeSecondNavPreferences: function () {
            this.closeSecondNav('preferences');
        },
        closeSecondNavPlans: function () {
            this.closeSecondNav('plans');
        },
        closeSecondNavPatrols: function () {
            this.closeSecondNav('patrols');
        },
        toggleHub: function(){
            this.showHub = !this.showHub;
            this.firstTimeHub = true;
        },
        closeHUB: function (key) {
            if (this.showHub && !this.firstTimeHub) {
                this.showHub = false;
                this.firstTimeHub = true;
            }
            else {
                this.firstTimeHub = false;
            }
        },
        hasHubAccess(universe){
            if(_find(this.permissions,(object)=>{
                    return object == 'global-access-'+universe;
                })){
                return true;
            }
            return false;
        },
        hideNav(){
            this.setShowNav(false);
        },
        closeManager(){
            sessionStorage.removeItem('ADMINV5_FROM');
        }
    },
    watch: {
        acl: function(newValue){
            this.$forceUpdate();
        },
        permissions: function(newValue){
            this.$forceUpdate();
        },
    }
}
</script>

<style lang="scss">
    .nav-logo {
        display: flex;
        align-items: center;
        justify-content: center;

        .logo-manager {
            width: $main-nav-width / 1.5;
            height: $main-nav-width / 1.5;
            border-radius: 50%;
            background-color: $main-white;
            color: $main-white;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                width: 75%;
            }
        }
    }

    .sfr, .beepiz {
        .sfrHub {
            width: 378px !important;
        }
    }

    // Only override the specific different styles for beepiz
    .beepiz .nav-logo .logo-manager {
        background-color: $beepiz-color;
    }

    .link-custom-icon {
        display: flex;
        justify-content: center;

        .custom-icon {
            border-radius: 999px;
            border: 2px solid #ff903a;
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #FFF;
            margin: auto;

            img {
                height: 45px !important;
                width: 45px !important;
                margin: 0 !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ui/Navbar.vue